import React from 'react'
import { navbar, nav, navitem, menuitem, Dropdown, Col,Row, Button, NavDropdown,MenuItem ,Nav} from 'react-bootstrap';
import { Router, Route, Link, IndexRoute, hashHistory, browserHistory, DefaultRoute, IndexLink } from 'react-router'
import {FormId_Recrutement , CLIENT_ID} from '../config.js'
import GetForm from './GetForm'
import { getItemAnonymous} from '../actions/user'
import { connect } from 'react-redux';
import {GET_FORM, SUBMIT_FORM,CREATE_FORM_ENTRIE} from '../actions/user';
import { UncontrolledAlert } from 'reactstrap';
import  Sidebar from "./Sidebar";

class Recrutement extends React.Component {
constructor(props){
  super(props);
  this.state={
    spinner_status:false,
  }
}
componentDidMount(){
    const url ='v1/forms/'+FormId_Recrutement+'/view/?client='+CLIENT_ID;
    this.setState({spinner_status:true});
    this.props.getItemAnonymous(url, GET_FORM);
  }
componentWillReceiveProps(nextProps) {
    this.setState({spinner_status:nextProps.spinner_status});
 }
    render() {
      const success  = this.props.success ? this.props.success :null;
      console.log('test mes' , {success});
    return (
	<div>
<section className="inner-intro bg-image  parallax parallax-background1 inner_page_background" style={{backgroundImage:'url("/assets/img/images/new_images/slide01.png")'}}>
            <div className="container">
                <div className="row title">
                    <h2 className="h2">Green Agro Business</h2>
                    <div className="page-breadcrumb">
                        <a>Nos services</a>/<span>Recrutement</span>
                    </div>
                </div>
            </div>
        </section>

        <section id="about" className="wow fadeIn ptb ptb-sm-80">
            <div className="container filigrane page_info">
                <div className="row text-center inside_content">
                  <div className="col-md-8">
                
                    <h3><img src="/assets/img/leaf.png" className="leaf-sidebar"/> RECRUTEMENT</h3>
               
               
              <p>Le capital humain de <b className="keywords">GREEN AGRO BUSINESS</b> constitue un des éléments clés de nos valeurs.</p>
              <p>A cet effet, la recherche et l’intégration de candidats dotés de compétences éprouvées mais également de jeunes qui contribueront à l’expansion de notre entreprise par leur optimisme, leur capacité à travailler en équipe et leur facilité d’adaptation; sont aujourd’hui <b className="keywords">un axe majeur de la politique des Ressources Humaines de </b>
              <b className="keywords">GREEN AGRO BUSINESS</b> ne reste pas insensible à l’insertion des personnes à mobilité réduite dans notre entreprise.
              </p><br/>
              <p>Contactez-nous pour faire partie de notre équipe</p>
              <p>Adresse : Keur Matar commune de keur Moussa Région de Thiés</p>
             {/* <ul className="link-small recru">
                           <li><a className="lowercase" href="mailto:contact@greenagrobusiness.com"><i className="fa fa-envelope"></i>contact@greenagrobusiness.com</a></li>
                           <li><a><i className="fa fa-phone left"></i>+221 33 825 74 44</a></li>
                           </ul>
             */}

              
                    
                     {this.props.success ?
                      <UncontrolledAlert color="success">
                          {this.props.success}
                      </UncontrolledAlert>
                      :
                      this.props.error ?
                        <UncontrolledAlert color="danger">
                           {this.props.error}
                      </UncontrolledAlert>
                        : null
                    
                    }


                        <div className="col-md-12"><GetForm fields={this.props.fields} title={this.props.title} 
                        formId={FormId_Recrutement} clientId={CLIENT_ID} spinner_status={this.state.spinner_status}
                        textbtn="Envoyer votre candidature"/>
                        </div>
                     
                       
                    </div>
                    <Sidebar/>           
                 
                    </div>
                
                </div>
            
        
        </section>




    </div>


  )
 }
}
function mapStateToProps(state, ownProps){
  return {
    fields: state.dynamicform.fields,
    title: state.dynamicform.title,
    success: state.dynamicform.success,
    error: state.dynamicform.error,
    spinner_status:state.dynamicform.spinner_status,

  }
}  
export default connect(mapStateToProps, {getItemAnonymous})(Recrutement);




// WEBPACK FOOTER //
// ./src/components/Recrutement.jsx